import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer data-testid="footer-section" className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        {/* Large brand name */}
        <div className="mb-12">
          <h2 className="text-5xl sm:text-6xl lg:text-8xl font-black tracking-tighter text-gray-900 font-heading leading-none">
            RENT<span className="text-red-600">COMING</span>
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 pt-8 border-t border-gray-200">
          {/* Links */}
          <div className="flex items-center gap-6">
            <Link
              to="/privacy-policy"
              data-testid="footer-privacy-link"
              className="text-sm text-gray-500 hover:text-gray-900 transition-colors font-body"
            >
              {t.footer.privacy}
            </Link>
            <Link
              to="/terms-and-conditions"
              data-testid="footer-terms-link"
              className="text-sm text-gray-500 hover:text-gray-900 transition-colors font-body"
            >
              {t.footer.terms}
            </Link>
          </div>

          {/* Copyright */}
          <p
            data-testid="footer-copyright"
            className="text-sm text-gray-400 font-body"
          >
            &copy; {new Date().getFullYear()} RentComing. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
